module.exports = __webpack_public_path__ + "img/logo.8af36a59.png";